import * as Actions from '../actions/warningDialog.actions'
import { SUBMIT } from 'app/constants/button'

const initialState = {
  open: false,
  title: '',
  description: '',
  submitText: '',
  closeText: '',
  type: SUBMIT,
  onSubmit: () => {},
  onClose: () => {},
}

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.OPEN_WARNING_DIALOG:
      return {
        ...state,
        open: true,
        title: action.payload.title,
        description: action.payload.description,
        submitText: action.payload.submitText,
        closeText: action.payload.closeText,
        type: action.payload.type,
        onSubmit: action.payload.onSubmit,
        onClose: action.payload.onClose,
      }
    case Actions.CLOSE_WARNING_DIALOG:
      return {
        ...state,
        open: false,
      }
    default: {
      return state
    }
  }
}
